<template>
  <div class="app-home">
    <h2 class="title">管理员查询</h2>
    <div
      @click="toView(obj)"
      class="card"
      v-for="(obj, idx) in lists"
      :key="idx"
    >
      <p>
        <img class="icon" :src="obj.icon" alt="icon" />
        <span> {{ obj.title }}</span>
      </p>
      <yzy-icon name="arrow" class="arrow" color="#306BE5" />
    </div>
    <div class="footer">
      <p @click="toLink">管理员职责说明</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      link: undefined,
      lists: [
        {
          title: "单位通讯录管理员",
          url: "/address",
          isLocal: true,
          icon: require("../assets/images/ic_Real.png"),
        },
        {
          title: "单位账户管理员",
          url: "/account",
          isLocal: true,
          icon: require("../assets/images/ic_Incident.png"),
        },
        // {
        //   title: "业务应用管理员",
        //   url: "https://www.baidu.com/",
        //   isLocal: false,
        //   icon: require("../assets/images/ic_Key.png"),
        // },
      ],
    };
  },
  components: {},
  created() {
    const status = +process.env.VUE_APP_ENV;
    switch (status) {
      case 1:
        this.link =
          "https://xtbgtest.digitalgd.com.cn/irc/irch5/transfer_page.html?router=article/info/563010082970625";
        break;
      case 2:
        this.link =
          "https://xtbgtest.digitalgd.com.cn/irc/irch5/transfer_page.html?router=article/info/563010082970625";
        break;
      case 3:
        this.link =
          "https://xtbg.digitalgd.com.cn/irc/irch5/transfer_page.html?router=article/info/564564861129784";
        break;
      case 4:
        this.link =
          "https://xtbg.gdzwfw.gov.cn/irc/irch5/transfer_page.html?router=article/info/565067372305920";
        break;
    }
  },
  methods: {
    toLink() {
      window.location.href = this.link;
    },
    toView(item) {
      if (item.isLocal) {
        this.$router.push(item.url);
      } else {
        window.location.href = item.url;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-home {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #f4f5f6;
  position: relative;
  padding-top: 16px;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 252px;
    background-image: linear-gradient(
      180deg,
      #3177ec 50%,
      rgba(49, 119, 236, 0) 100%
    );
  }
}
.footer {
  font-size: 34px;
  color: #3076ec;
  letter-spacing: 0;
  line-height: 48px;
  font-weight: 400;
  position: absolute;
  bottom: 25px;
  width: 100%;
  text-align: center;
}
.title {
  position: relative;
  z-index: 11;
  font-size: 68px;
  color: #ffffff;
  letter-spacing: 0.75px;
  line-height: 82px;
  margin-bottom: 32px;
  margin-left: 48px;
}
.card {
  position: relative;
  z-index: 11;
  width: 686px;
  height: 144px;
  margin: 0 auto;
  margin-bottom: 32px;
  background: #ffffff;
  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  font-size: 40px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 24px 0 48px;
  & > p {
    display: flex;
    align-items: center;
    & > span {
      opacity: 0.87;
    }
    .icon {
      width: 64px;
      height: 64px;
      margin-right: 32px;
    }
  }
}
</style>
